import React, { useEffect, useState } from "react";
import { db } from "./firebase.js";
import { collection, getDocs, query, where, deleteDoc, doc } from "firebase/firestore";
import AdminEventi from "./AdminEventi.jsx";
import AdminScontistiche from "./AdminScontistiche.jsx";
import './AdminPanel.css';


// Librerie per export Excel
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import AdminBilancio from "./AdminBilancio.jsx";

const isAdmin = true;

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState("");
  const [iscrizioni, setIscrizioni] = useState([]);
  const [loadingIscrizioni, setLoadingIscrizioni] = useState(false);

  // Filtri iscrizioni
  const [filtroDipartimento, setFiltroDipartimento] = useState("");
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCognome, setFiltroCognome] = useState("");
  const [filtroCorso, setFiltroCorso] = useState("");

  const fetchIscrizioni = async () => {
    setLoadingIscrizioni(true);
    try {
      let q = collection(db, "iscrizioni");
      const conditions = [];
      if (filtroDipartimento) conditions.push(where("dipartimento", "==", filtroDipartimento));
      if (filtroNome) conditions.push(where("nome", "==", filtroNome));
      if (filtroCognome) conditions.push(where("cognome", "==", filtroCognome));
      if (filtroCorso) conditions.push(where("corsoDiLaurea", "==", filtroCorso));
      if (conditions.length) q = query(collection(db, "iscrizioni"), ...conditions);
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setIscrizioni(data);
    } catch (err) {
      console.error(err);
    }
    setLoadingIscrizioni(false);
  };

  const handleDeleteIscrizione = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questa iscrizione?")) return;
    await deleteDoc(doc(db, "iscrizioni", id));
    setIscrizioni(prev => prev.filter(i => i.id !== id));
  };

  // Funzione export Excel (TUTTI i campi del form)
  const handleExportExcel = () => {
    if (!iscrizioni.length) {
      alert("Nessun dato da esportare");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(iscrizioni.map(i => ({
      Nome: i.nome,
      Cognome: i.cognome,
      "Luogo di Nascita": i.luogoNascita,
      "Data di Nascita": i.dataNascita,
      "Tipo Documento": i.tipoDocumento,
      "Numero Documento": i.numeroDocumento,
      Telefono: i.telefono,
      Dipartimento: i.dipartimento,
      "Corso di Laurea": i.corsoDiLaurea,
      Livello: i.livello,
      Matricola: i.matricola,
      Email: i.email,
      Cellulare: i.cellulare,
    })));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Iscrizioni");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "iscrizioni.xlsx");
  };

  if (!isAdmin) return <p>Accesso negato</p>;

  return (
    <div className="admin-container">
      <h2>Dashboard Admin</h2>

      {/* ---------- Menu iniziale ---------- */}
      {activeTab === "" && (
        <div className="admin-tabs">
          <button className="admin-tab" onClick={() => { setActiveTab("iscrizioni"); fetchIscrizioni(); }}>
            Database Iscrizioni
          </button>
          
          <button className="admin-tab" onClick={() => setActiveTab("bilancio")}>Gestione Bilancio</button>


          <button className="admin-tab" onClick={() => setActiveTab("eventi")}>
            Gestione Eventi
          </button>
          <button className="admin-tab" onClick={() => setActiveTab("scontistiche")}>
            Gestione Scontistiche
          </button>
        </div>
      )}
      
      {/* ---------- Database Iscrizioni ---------- */}
      {activeTab === "iscrizioni" && (
        <>
          <button className="admin-back" onClick={() => setActiveTab("")}>⬅ Torna alla Dashboard</button>
          <h3>Iscrizioni</h3>

          <div className="admin-filters">
            <select value={filtroDipartimento} onChange={e => setFiltroDipartimento(e.target.value)}>
              <option value="">Tutti i dipartimenti</option>
              <option value="demm">DEMM</option>
              <option value="dst">DST</option>
              <option value="ding">DING</option>
            </select>
            <input type="text" placeholder="Nome" value={filtroNome} onChange={e => setFiltroNome(e.target.value)} />
            <input type="text" placeholder="Cognome" value={filtroCognome} onChange={e => setFiltroCognome(e.target.value)} />
            <input type="text" placeholder="Corso di Laurea" value={filtroCorso} onChange={e => setFiltroCorso(e.target.value)} />
            <button className="admin-button" onClick={fetchIscrizioni}>Applica filtri</button>
            <button className="admin-button" onClick={handleExportExcel}>📥 Esporta in Excel</button>
          </div>

          {loadingIscrizioni ? <p>Caricamento...</p> : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Cognome</th>
                  <th>Email</th>
                  <th>Dipartimento</th>
                  <th>Corso di Laurea</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {iscrizioni.map(i => (
                  <tr key={i.id}>
                    <td>{i.nome}</td>
                    <td>{i.cognome}</td>
                    <td>{i.email}</td>
                    <td>{i.dipartimento}</td>
                    <td>{i.corsoDiLaurea}</td>
                    <td>
                      <button className="admin-button" onClick={() => handleDeleteIscrizione(i.id)}>Elimina</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}

      {/* ---------- Gestione Eventi ---------- */}
      {activeTab === "eventi" && (
        <>
          <button className="admin-back" onClick={() => setActiveTab("")}>⬅ Torna alla Dashboard</button>
          <AdminEventi />
        </>
      )}
        {/* ---------- Gestione Bilancio ---------- */}
      {activeTab === "bilancio" && (
        <>
          <button className="admin-back" onClick={() => setActiveTab("")}>⬅ Torna alla Dashboard</button>
          <AdminBilancio />
        </>
      )}
      {/* ---------- Gestione Scontistiche ---------- */}
      {activeTab === "scontistiche" && (
        <>
          <button className="admin-back" onClick={() => setActiveTab("")}>⬅ Torna alla Dashboard</button>
          <AdminScontistiche />
        </>
      )}
    </div>
  );
}
